
const API_BASE_URL = process.env.REACT_APP_API_URL;
console.log("API_BASE_URL:", API_BASE_URL);
type AuthResponse = {
  success: boolean;
  message?: string;
  authToken?: string;
};

type SignInPayload = {
  email: string;
  password: string;
};

type SignUpPayload = {
  email: string;
  password: string;
  confirmPassword: string;
};

/* ---------- SIGN IN ---------- */
export const signIn = async (
  data: SignInPayload
): Promise<AuthResponse> => {
  const response = await fetch(`${API_BASE_URL}/auth/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    // credentials: "include", // IMPORTANT for cookies/session
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error("Sign in failed: " + response.statusText);
  }

  return response.json();
};

/* ---------- SIGN UP ---------- */
export const signUp = async (
  data: SignUpPayload
): Promise<AuthResponse> => {
  const response = await fetch(`${API_BASE_URL}/auth/register`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    // credentials: "include",
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error("Sign up failed");
  }

  return response.json();
};
